const KEYCLOAK_URL = process.env.REACT_APP_KEYCLOAK_URL || '';
const KEYCLOAK_REALM = process.env.REACT_APP_KEYCLOAK_REALM || '';
const KEYCLOAK_CLIENT_ID = process.env.REACT_APP_KEYCLOAK_CLIENT_ID || '';
const KEYCLOAK_SCOPE = process.env.REACT_APP_KEYCLOAK_SCOPE || 'openid profile email';
const KEYCLOAK_REDIRECT_URI =
  process.env.REACT_APP_KEYCLOAK_REDIRECT_URI || `${window.location.origin}/login/keycloak/callback`;
const KEYCLOAK_LOGOUT_REDIRECT_URI =
  process.env.REACT_APP_KEYCLOAK_LOGOUT_REDIRECT_URI || `${window.location.origin}/`;

const hasKeycloakConfig = Boolean(KEYCLOAK_URL && KEYCLOAK_REALM && KEYCLOAK_CLIENT_ID);
const baseHost = KEYCLOAK_URL.replace(/\/+$/, '').replace(/\/realms$/, '');



export const keycloakConfig = {
  hasKeycloakConfig,
  clientId: KEYCLOAK_CLIENT_ID,
  scope: KEYCLOAK_SCOPE,
  redirectUri: KEYCLOAK_REDIRECT_URI,
  logoutRedirectUri: KEYCLOAK_LOGOUT_REDIRECT_URI,
  authEndpoint: `${baseHost}/realms/${KEYCLOAK_REALM}/protocol/openid-connect/auth`,
  tokenEndpoint: `${baseHost}/realms/${KEYCLOAK_REALM}/protocol/openid-connect/token`,
  logoutEndpoint: `${baseHost}/realms/${KEYCLOAK_REALM}/protocol/openid-connect/logout`,
};

function randomString(length = 64) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
  const array = new Uint8Array(length);
  window.crypto.getRandomValues(array);
  return Array.from(array, (x) => chars[x % chars.length]).join('');
}

function base64UrlEncode(bytes) {
  const binary = String.fromCharCode(...bytes);
  return window.btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

async function sha256(plain) {
  const data = new TextEncoder().encode(plain);
  return window.crypto.subtle.digest('SHA-256', data);
}

export async function startKeycloakLogin() {
  if (!keycloakConfig.hasKeycloakConfig) {
    throw new Error('Keycloak belum dikonfigurasi.');
  }

  const state = randomString(32);
  const codeVerifier = randomString(96);
  const codeChallenge = base64UrlEncode(new Uint8Array(await sha256(codeVerifier)));

  sessionStorage.setItem('kc_state', state);
  sessionStorage.setItem('kc_code_verifier', codeVerifier);

  const params = new URLSearchParams({
    client_id: keycloakConfig.clientId,
    response_type: 'code',
    scope: keycloakConfig.scope,
    redirect_uri: keycloakConfig.redirectUri,
    state,
    code_challenge: codeChallenge,
    code_challenge_method: 'S256',
  });

  window.location.assign(`${keycloakConfig.authEndpoint}?${params.toString()}`);
}
